"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    Android: 'android',
    iOS: 'ios',
};
